export const IMPORT_PHASE = {
    IDLE: 'idle',
    READING: 'reading',
    CHOOSING: 'choosing',
    APPLYING: 'applying',
} as const;

export type ImportPhase = (typeof IMPORT_PHASE)[keyof typeof IMPORT_PHASE];

export const IMPORT_MODE = {
    REPLACE: 'replace',
    APPEND: 'append',
} as const;

export type ImportMode = (typeof IMPORT_MODE)[keyof typeof IMPORT_MODE];

/** Filename prefix for S3 image metadata — same literal Reports persist uses. */
export const IMPORT_UPLOAD_SOURCE = 'report' as const;

export const IMPORT_TOASTS = {
    BAD_TYPE: 'Please choose a .md, .doc, or .docx file',
    EMPTY: "Couldn't read any content from that file",
    LEGACY_DOC: "Legacy .doc isn't supported — please re-save it as .docx and try again",
    FAILED: 'Failed to import the document',
} as const;

export const IMPORT_COPY = {
    TITLE: 'Import Document',
    SUBTITLE: 'Do you want to replace the entire document or append the imported content to the existing one?',
    READING: 'Reading document…',
    APPLYING: 'Adding content to the editor…',
    CANCEL: 'Cancel',
    APPEND: 'Append',
    REPLACE: 'Replace Document',
    BUTTON: 'Import',
    ARIA: 'Import document',
    TITLE_ATTR: 'Import document (Markdown or Word)',
} as const;
